<template>
    <div>
        <ul class="nav nav-pills mb-1 row g-1" role="tablist">
            <li class="nav-item col-3">
                <div class="nav-link text-center active px-2" data-bs-toggle="tab" data-bs-target="#OneYear" type="button" role="tab"><small>1 year</small></div>
            </li>
            <li class="nav-item text-center col-3">
                <div class="nav-link px-2" data-bs-toggle="tab" data-bs-target="#TwoYear" type="button" role="tab"><small>2 year</small></div>
            </li>
            <li class="nav-item text-center col-3">
                <div class="nav-link px-2" data-bs-toggle="tab" data-bs-target="#FiveYear" type="button" role="tab"><small>5 year</small></div>
            </li>
            <li class="nav-item text-center col-3">
                <div class="nav-link px-2" data-bs-toggle="tab" data-bs-target="#floating" type="button" role="tab"><small>Floating</small></div>
            </li>
        </ul>

        <div v-if="loading" class="text-center border p-3">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div class="tab-content" v-if="!loading">
            <div id="OneYear" class="tab-pane active">
                <table class="table table-striped table-bordered table-hover">
                    <tbody>
                    <tr v-for="rate in rates.one_year ?? []" :key="rate.id">
                        <td class="lenderName">{{ rate.lender_name }}</td>
                        <td class="rate_1year">{{ rate.rate_1year }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div id="TwoYear" class="tab-pane fade">
                <table class="table table-striped table-bordered table-hover">
                    <tbody>
                    <tr v-for="rate in rates.two_year ?? []" :key="rate.id">
                        <td class="lenderName">{{ rate.lender_name }}</td>
                        <td class="rate_2year">{{ rate.rate_2year }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div id="FiveYear" class="tab-pane fade">
                <table class="table table-striped table-bordered table-hover">
                    <tbody>
                    <tr v-for="rate in rates.five_year ?? []" :key="rate.id">
                        <td class="lenderName">{{ rate.lender_name }}</td>
                        <td class="rate_5year">{{ rate.rate_5year }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div id="floating" class="tab-pane fade">
                <table class="table table-striped table-bordered table-hover">
                    <tbody>
                    <tr v-for="rate in rates.floating ?? []" :key="rate.id">
                        <td class="lenderName">{{ rate.lender_name }}</td>
                        <td class="rate_floating">{{ rate.rate_floating }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <p v-if="rates.length < 1" class="text-center">No Rates</p>
        <a href="/mortgage-rates" class="small fw-bold text-primary">View All Rates</a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            rates: [],
            columns: [
                {label: 'Lender', sortKey: 'lender_name'},
                {label: 'Flt', sortKey: 'rate_floating'},
                {label: '1Yr', sortKey: 'rate_1year'},
                {label: '2Yr', sortKey: 'rate_2year'},
                {label: '3Yr', sortKey: 'rate_3year'},
            ],
            currentSort: '',
            currentSortDir: 'asc',
        };
    },

    mounted() {
        this.getTopRates()
    },

    methods: {
        getTopRates() {
            this.loading = true;
            axios({
                method: 'get',
                url: '/mortgage/top-rates'
            }).then(res => {
                this.rates = res.data;
            }).catch(err => {
                console.log({error: err});
            }).finally(() => {
                this.loading = false;
            })
        },
    },
}
</script>

<style scoped>
td {
    font-size: 14px;
}

th {
    font-size: 14px;
    font-weight: bold;
}

.nav-link {
    border-radius: 3px !important;
    padding: .25rem .75rem !important;
}

.nav-link {
    border: 1px solid #dee2e6 !important;
    border-radius: 3px !important;
    padding: .25rem .75rem !important;
}

</style>
